<template>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title class="headline">
          Dodaj przekierowanie
        </v-card-title>
        <v-card-text>
          <v-form
              ref="newForm"
              v-model="valid"
              lazy-validation
              class="dimension--form mt-5 mb-5"
          >
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-text-field
                    v-model="form.from"
                    :rules="formRules.from"
                    class="pt-0"
                    type="url"
                    label="Adres źródłowy"
                ></v-text-field>
                <v-text-field
                    v-model="form.to"
                    :rules="formRules.to"
                    class="pt-0"
                    type="url"
                    label="Adres docelowy"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  @click.prevent="onSubmit"
                  type="Submit"
                  class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                  large
              >Dodaj&nbsp;<v-icon size="24">mdi-send</v-icon></v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>

import api from "@/services/api";

export default {
  name: 'ModalAddRedirect',
  props: {
    item: {},
  },
  mixins: [
  ],
  created() {
  },
  data() {
    return {
      dialog: false,
      form: {
        from: '',
        to: '',
      },
      formRules: {
        from: [(value) => !!value || 'Wpisz adres źródłowy'],
        to: [(value) => !!value || 'Wpisz adres docelowy'],
      },
      valid: false,
    }
  },
  methods: {
    open() {
      this.dialog = true
    },
    async onSubmit() {
      if (!this.$refs.newForm.validate()) {
        return
      }

      const redirect = {
        from: this.form.from,
        to: this.form.to,
      }
      api
          .post('/api/redirects' , redirect)
          .then(() => {
            this.$root.$emit('notifySuccess', {
              html: 'Przekierowanie zostało dodane.',
            });
            this.dialog = false;
            this.form.from = '';
            this.form.to = '';
            this.$parent.getRedirects();
          })
          .catch((error) => {
            console.error('Error when adding a redirect:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    },
  },
}
</script>

<style scoped></style>
